module.exports = function(service) {
	'use strict'
	service.factory('addToOther',addToOther);
	addToOther.$inject=['$rootScope','postDataService','refreshtokenService','serverError','alertService','offlineError'];
	function addToOther($rootScope,postDataService,refreshtokenService,serverError, alertService, offlineError) {
        return function(url, postData) {
            if(!postData) {
              postData = null
            }
            $rootScope.hasLoaded = false;
            var postFunction = function() {   
              postDataService.save(url,postData).$promise.then(function(postData){
                $rootScope.hasLoaded = true;
                alertService('success','Success ', postData.message, 2000);
              }, function(error){
                if(!window.navigator.onLine) {
                  offlineError()
                  alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                  return
                }
                if(error.status ==401) {
                  var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {   
                        postFunction();
                      }
                    },
                    function(error) {
                      // report something
                    },
                    function(progress) {
                      // report progress
                  });
                }else if(error.status ==502) {
                  serverError();
                }else {
                  alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                }
                $rootScope.hasLoaded = true;
              });
            }
            postFunction();
          }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/addToOtherService.js
// module id = 582
// module chunks = 0